import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-team',
  standalone: true,
  imports: [],
  templateUrl: './process-team.component.html',
  styles: ``
})
export class ProcessTeamComponent {
  @Input() process!: Process;
}
